import { cn } from '@/utils/ui'
import * as React from 'react'
import { useFormContext } from 'react-hook-form'

const Textarea: React.FC<
  {
    ref?: React.Ref<HTMLTextAreaElement>
    hasError?: boolean
    name: string
    defaultValue?: string
    required?: boolean
  } & React.TextareaHTMLAttributes<HTMLTextAreaElement>
> = ({ className, hasError = false, ref, name, defaultValue, required, ...props }) => {
  const { watch, register } = useFormContext()
  const value = name ? watch(name) : undefined

  return (
    <textarea
      className={cn(
        `flex min-h-[128px] w-full rounded-md border mt-2 ${
          hasError ? `!bg-bg-error border-border-error` : `border-border-input bg-background`
        } p-2 !text-body-XS-regular w-full bg-background px-3 py-2
        ring-offset-background placeholder:text-text-faded
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus focus-visible:ring-offset-2
        disabled:cursor-not-allowed disabled:opacity-50`,
        value && 'text-text-base',
        className,
      )}
      placeholder={!value ? defaultValue?.toString() : undefined}
      {...register(name, { required: required ?? false })}
      {...props}
    />
  )
}

export { Textarea }
